export enum SortOptions {
  PING_OLDEST = 'PING_OLDEST',
  PING_NEWEST = 'PING_NEWEST',
  NAME_A_Z = 'NAME_A_Z',
  NAME_Z_A = 'NAME_Z_A',
}

export const SORT_OPTIONS_VALUES = Object.keys(SortOptions).map(key => SortOptions[key as keyof typeof SortOptions]);
